/*
Card array rendered on the App using the JavaScript map method to represent the images on the "front of the card".
Source of images: All images used in this project are sourced from Unsplash - free high resolution images @ <https://unsplash.com/>
*/

const cardArray = [
  //Image of a Lamborghini.
  {
    imgName: "Lamborghini",
    img: "https://images.unsplash.com/photo-1580414057403-c5f451f30e1c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    cardMatched: null,
  },

  //Image of Mercedes G-wagon.
  {
    imgName: "Mercedes G-wagon",
    img: "https://images.unsplash.com/photo-1559038465-e0ca2910a5b1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8ZyUyMHdhZ29ufGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    cardMatched: null,
  },

  //Image of the Eiffel tower.
  {
    imgName: "Eiffel tower",
    img: "https://images.unsplash.com/photo-1511739001486-6bfe10ce785f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8ZWlmZWwlMjB0b3dlcnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
    cardMatched: null,
  },
  //Image of a Casino slot machine.
  {
    imgName: "Casino slot machine",
    img: "https://images.unsplash.com/photo-1604028296525-8304e1a4969f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    cardMatched: null,
  },
];

export default cardArray;
